export const ENV = {
  PRODUCT_API_ENDPOINT: import.meta.env.VITE_PRODUCT_API_ENDPOINT || "",
  AUTH_PORTAL_URL: import.meta.env.VITE_AUTH_PORTAL_URL || "",
  PRODUCT_ID: import.meta.env.VITE_PRODUCT_ID || "admin",
  COGNITO_USERPOOL_ID: import.meta.env.VITE_COGNITO_USERPOOL_ID || "",
  CLIENT_ID: import.meta.env.VITE_COGNITO_CLIENT_ID || "",
  ENV: import.meta.env.VITE_ENV || "dev",
};
